function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M59.656 88.313c15.79 0 28.657-12.867 28.657-28.657S75.445 31 59.656 31 31 43.866 31 59.656s12.866 28.657 28.656 28.657zm0-53.765c13.841 0 25.109 11.267 25.109 25.108 0 13.841-11.268 25.108-25.109 25.108-13.84 0-25.108-11.267-25.108-25.108 0-13.84 11.267-25.108 25.108-25.108z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.434 77.59c-.43-.467-.663-1.13-.663-1.988v-1.014c0-.857.234-1.52.663-1.988.429-.468 1.091-.702 1.95-.702h.584c.858 0 1.481.234 1.95.702.428.468.662 1.13.662 1.988v1.014c0 .858-.234 1.52-.663 1.989-.428.468-1.091.701-1.949.701h-.585c-.858 0-1.52-.234-1.95-.701zm.663-12.164l-1.17-21.21c-.078-.935.156-1.676.663-2.3.507-.584 1.208-.896 2.066-.896.897 0 1.599.312 2.066.896.507.624.702 1.365.624 2.3l-1.13 21.21c-.04.585-.195 1.014-.468 1.287-.273.273-.624.429-1.092.429-.975 0-1.52-.585-1.56-1.716z",
  fill: "#00BAC3"
});

function SvgCircleExclamation(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCircleExclamation;